import { render, staticRenderFns } from "./PromotionModal.vue?vue&type=template&id=12c352c6&scoped=true&"
import script from "./PromotionModal.vue?vue&type=script&lang=js&"
export * from "./PromotionModal.vue?vue&type=script&lang=js&"
import style0 from "./PromotionModal.vue?vue&type=style&index=0&id=12c352c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c352c6",
  null
  
)

export default component.exports